module.exports = __webpack_public_path__ + "static/media/Angle's Class II Division I18.e8aeb91a.png";